export enum GCStatusType {
    Invited = 0,
    NeedsProject = 1,
    Pending = 2,
    Activated = 3,
}
